import React, { useState } from "react";
import { PageHeader } from "./PageHeader";
import { DataTable } from "./DataTable";
import useNavModel, { RouterParamType } from "@/model/navModel";

export default () => {
    const { getSelectedNavState } = useNavModel();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
    return (
        <>
            <PageHeader {...detailsInfo}/>
            <DataTable {...detailsInfo}/>
        </>
    )
}